import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Prevents "Commerciale" users from accessing the route.
 * Redirects to /businesses if they try to access a restricted route.
 */
export const noCommercialeGuard: CanActivateFn = () => {
  const router = inject(Router);
  const isCommerciale = sessionStorage.getItem('commerciale') === 'true';

  if (isCommerciale) {
    router.navigate(['/businesses']);
    return false;
  }

  return true;
};
